import React from 'react';
import {connect} from 'react-redux';
import {submit, isSubmitting, isInvalid} from 'redux-form';

import {openModal, MODALS as BASE_MODALS} from 'ducks/modals';
import {
  fetchOneOffChargeReasons,
  selectOneOffChargeReasons,
  fetchPaymentMethods,
  selectPaymentMethods
} from 'ducks/oneOffChargeReasons';

import {default as Modal, withModal} from 'components/Modal';
import {AddInvoiceItemAndPaymentForm, Buttons} from './components';

class OneOffChargeModal extends React.Component<any> {
  componentDidMount() {
    const {locationRef} = this.props;

    // TODO: Add permissions !!!
    this.props.fetchOneOffChargeReasons({locationRef});
    this.props.fetchPaymentMethods({locationRef});
  }

  render() {
    const {
      bookingId,
      tenancyId,
      oneOffChargeReasons,
      paymentMethods,
      form: {submitting, invalid}
    } = this.props;
    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        type={Modal.EXTRA_SMALL}
        className="OneOffChargeModal">
        <Modal.Header heading="Add item" />
        <Modal.Body>
          <AddInvoiceItemAndPaymentForm
            oneOffChargeReasons={oneOffChargeReasons}
            paymentMethods={paymentMethods}
            bookingId={bookingId}
            tenancyId={tenancyId}
            extraActions={this.props.extraActions}
          />
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            submitting={submitting}
            invalid={invalid}
            onSubmit={this.props.openConfirmChargeModal}
            closeModal={this.props.closeModal}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  oneOffChargeReasons: selectOneOffChargeReasons(state),
  paymentMethods: selectPaymentMethods(state),
  form: {
    submitting: isSubmitting('createOneOffChargeInvoiceAndPayment')(state),
    invalid: isInvalid('createOneOffChargeInvoiceAndPayment')(state)
  }
});

const mapDispatchToProps = {
  submit,
  fetchOneOffChargeReasons,
  fetchPaymentMethods,
  openModal
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withModal(BASE_MODALS.ONE_OFF_CHARGE)(OneOffChargeModal)
);
